import { Component, inject } from '@angular/core';
import { ModalIframeService } from '../../commons/components/modal-iframe/modal-iframe.service';
import { ModalImageService } from '../../commons/components/modal-image/modal-image.service';

@Component({
    selector: 'oaj-help-itx',
    templateUrl: './help.component.html',
    styleUrls: ['./help.component.css']
})
export class HelpComponent {
    private modalIframeService: ModalIframeService = inject(ModalIframeService);
    private modalImageService: ModalImageService = inject(ModalImageService);

    /**
     * Funcion para abrir el modal del video, se muestra una modal con el video dependiendo de la fuente y el titulo proporcionados
     * @param videoSrc 
     * @param videoTitle 
     */
    openVideoModal(videoSrc: string, videoTitle: string) {
        this.modalIframeService.open(videoTitle, videoSrc, 'Cerrar', 'xl');
    }

     /**
     * Función para abrir el modal de imagen con opción de descarga
     * @param imageUrl 
     * @param imageTitle 
     * @param downloadFileName 
     */
    openImageModal(imageUrl: string, imageTitle: string, downloadFileName: string) {
        this.modalImageService.open(imageTitle, imageUrl, downloadFileName, 'xl');
    }

    /**
     * Función para abrir el modal de guía interactiva (HTML embebido)
     * @param guideUrl URL de la guía interactiva
     * @param guideTitle Título de la guía
     */
    openInteractiveGuideModal(guideUrl: string, guideTitle: string) {
        this.modalIframeService.open(guideTitle, guideUrl, 'Cerrar', 'xl');
    }

}